<template>
  <div>
    <h2>{{ $t('title.switch-groups') }}</h2>

    <base-list
    model="switch-groups"
    :columns="['name', 'description']"
    sModel="switch-group"
    />

  </div>

</template>

<script>
import BaseList from 'components/BaseList'

export default {
  name: 'switch-group-list',
  components: { BaseList }
}
</script>


// WEBPACK FOOTER //
// SwitchGroupList.vue?607664ae